
import { Prop, Component, Watch } from "vue-property-decorator";
import { BaseTableCore } from "./base-table-core";
import { defaultPopoverData, ITablePopoverData } from "./core";

@Component
export default class TablePopover extends BaseTableCore {
    @Prop({ type: Object, required: false })
    declare data: ITablePopoverData;
    get mergedData() {
        return {
            ...defaultPopoverData,
            ...this.data,
        };
    }

    @Prop({ type: Object, required: false, default: null })
    selected!: Record<string, any> | null;

    /// watchers
    @Watch("selected")
    onSelectedUpdated(selected: Record<string, any> | null) {
        if (selected == null) return;

        /// next tick for $ref
        this.$nextTick(() => {
            /// next tick for popover handle
            this.$nextTick(() => {
                (this.$refs.popover as any).$emit("open");
                // (this.$refs.popover as any).show();
            });
        });
    }

    /// private helpers
    async onPopoverShow(obj) {
        // Get the root element of the current Vue component
        const element = this.$parent?.$el;
        // Compute the effective z-index of the element
        const zIndex = getEffectiveZIndex(element);
        // Set the computed z-index into the event object to adjust the popover's stacking context
        let component: any;
        while (!(component = document.getElementById(obj.componentId))) {
            if (component != null) break;
            await new Promise((resolve) => this.$nextTick(resolve));
        }
        component.style.zIndex = String(zIndex + 1);
    }

    get bindAttrs() {
        return {
            $attrs: {
                value: this.selected,
            },
            $props: {},
        };
    }
}

function getEffectiveZIndex(element) {
    let current = element;
    let zIndex: number = 0;
    while (current && current instanceof Element) {
        const style = window.getComputedStyle(current);
        const zidx = style.zIndex;
        if (zidx !== "auto") {
            zIndex = parseInt(zidx, 10);
        }
        current = current.parentElement;
    }
    return zIndex;
}
